module.exports = __webpack_public_path__ + "img/higgs_module_contacts.fbdfba9d.png";